import { createWithEqualityFn } from "zustand/traditional";
import { shared } from "use-broadcast-ts";

const useAppStore = createWithEqualityFn(
  shared((set) => ({
    totalPages: 0,
    pageNum: 1,
    pageSize: 10,
    restaurantName: "",
    restaurantId: "",
    isChanged:false,
    loading: false,
    dateRange: [
      {
        startDate: null,
        endDate: null,
        key: "selection"
      }
    ],
    jobDateRange:[
      {
        startDate: null,
        endDate: null,
        key: "selection"
      }
    ],
    reportType: null,
    logType: null,
    lineItemSplitData: [],
    categoryChoices: [],
    theme: localStorage.getItem("theme") || "light",
    setTheme: (theme) => {
      localStorage.setItem("theme", theme);
      set({ theme });
    },
    toggleTheme: () =>
      set((state) => {
        const next = state.theme === "dark" ? "light" : "dark";
        localStorage.setItem("theme", next);
        return { theme: next };
      }),
    setTotalPages: (totalPages) => set({ totalPages }),
    setPageNum: (pageNum) => set({ pageNum }),
    setRestaurantName: (restaurantName) => set({ restaurantName }),
    setRestaurantId: (restaurantId) => set({ restaurantId }),
    setLoading: (loading) => set({ loading }),
    setStartDate: (startDate) => set({ startDate }),
    setIsChanged:(ans)=>set({isChanged:ans}),
    setEndDate: (endDate) => set({ endDate }),
    setDateRange: (dateRange) => set({ dateRange }),
    setJobDateRange: (jobDateRange) => set({ jobDateRange }),
    setReportType: (reportType) => set({ reportType }),
    setLogType: (logType) => set({ logType }),
    setLineItemSplitData: (lineItemSplitData) => set({ lineItemSplitData }),
    setCategoryChoices: (categoryChoices) => set({ categoryChoices})
  })),
  Object.is
);

export default useAppStore;
